const Footer = () => {
  return (
    <div className="footer">
      © Davide Betterini
    </div>
  )
}

export default Footer